import React, { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { memberMobx, decorationMobx } from '@mobxStore'
import { each, find } from '@dt/fe-utils/dist/lodash'
import { useHistoryNew } from '@utils'
import mktController from 'controllers/mktController'
import './index.scss'

import unCouopnImg from '@img/member/un-coupon.png'

interface IProps { }

const UnacquiredCoupon: FC<IProps> = (props: IProps) => {
  const history = useHistoryNew()
  const { unacquiredCoupons, getUnacquiredCoupons } = memberMobx
  const { mktDecorates } = decorationMobx
  const [unacquiredCnt, setUnacquiredCnt] = useState<number>(0)
  let info: any = find(mktDecorates.market, (item: any) => item.key === 'receiveCoupon')
  if (!info) {
    info = find(mktDecorates.notMarket, (item: any) => item.key === 'receiveCoupon') || {}
  }
  const handleGo = () => {
    mktController.checkLogin(history).then(() => {
      history.push('/iCoupon/coupon/get')
    })
  }
  useEffect(() => {
    if (unacquiredCoupons.length > 0) {
      const couponIds: any[] = []
      const couponArr: any[] = []
      let couponCnt: number = 0
      each(unacquiredCoupons, (item: any) => {
        each(item.coupons, (cItem: any) => {
          if (!couponIds.includes(cItem.couponId)) {
            couponIds.push(cItem.couponId)
          }
          for (let i = 0; i < cItem.couponCnt; i++) {
            couponArr.push({
              couponId: cItem.couponId
            })
          }
          couponCnt += cItem.couponCnt
        })
      })
      setUnacquiredCnt(couponCnt)
    }
  }, [unacquiredCoupons])
  useEffect(() => {
    if (unacquiredCoupons.length === 0 && memberMobx.token) {
      getUnacquiredCoupons()
    }
  }, [])
  if (unacquiredCoupons.length === 0) return <></>
  return (
    <div data-cypid='mmgToUnAquiredCoupon' className='coupon-panel' onClick={handleGo}>
      {
        !info.hideTitle &&
          <div className='coupon-panel-block' style={{ color: info.titleColor || '#161616' }}>
            <div className='title'>{i18n.t('pageName.coupon')}</div>
            <div className='des'>{i18n.t('mkt.member.hasSomeCouponsGet', { number: unacquiredCnt })}</div>
          </div>
      }
      <img src={info.img || unCouopnImg} alt='' />
    </div>
  )
}

export default observer(UnacquiredCoupon)
